/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /*-------------------------
      UNIQUE CUSTOM JS
 --------------------------*/

/* -------------------*/
/* LANGUAGES DROPDOWN */
/* -------------------*/

$('[data-dropdown-handle]').unbind('click');

$('[data-dropdown-handle]').on('click', function(e) {
  e.preventDefault();

  if ($(this).closest('[data-dropdown]').attr('data-dropdown') === 'opened') {
    $(this).closest('[data-dropdown]').attr('data-dropdown', '');
  } else {
    if ($(this).closest('[data-dropdown-group]').length > 0) {
      $(this).closest('[data-dropdown-group]').find('[data-dropdown]').attr('data-dropdown', '');
    }

    $(this).closest('[data-dropdown]').attr('data-dropdown', 'opened');
  }
});

/* --------------------*/
/* PRODUCT LINK TO B2B */
/* --------------------*/

let productHandle = $('[data-product-handle]').attr('data-product-handle');
let rootUrl = $('[data-external-url]').attr('data-external-url');
let lastChar;
let char = '';

if(rootUrl) {
  let lastChar = rootUrl.slice(-1);
}

if(lastChar !== '/') {
  char = '/';
}

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant;
  $('.unique-b2b-link').attr('href', rootUrl + char + 'products/' + productHandle + '?variant=' + variant.id);
});

/* ---------------------------------*/
/* SCROLLTOP WHEN SUBMIT NEWSLETTER */
/* ---------------------------------*/

setTimeout(function () {
  if($('.shopify-challenge__container').length) {
    $('html, body').animate({scrollTop:0}, 500);
  }
}, 1000);

/* ----------------*/
/* PRODUCT GALLERY */
/* ----------------*/

// Switch galleries when variant changes

if($('body').hasClass('template-product')) {
  $('[data-option-handle]').on('click', function(event) {
    $('.unique-product-gallery-wrapper').removeClass('is-selected');

    let targetOption = $(this).attr('data-option-handle');
    let gallery = $('.unique-product-gallery-wrapper[data-gallery-handle="'+ targetOption +'"]');

    gallery.addClass('is-selected');
  });
}

// Swiper

$('.unique-product-gallery').each(function(index, element){
  let $this = $(this);
  $this.addClass('instance-' + index);
  //let thumbs = $('.unique-gallery-thumbnails.instance-' + index);
  let swiper = new Swiper('.instance-' + index, {
    direction: 'vertical',
    zoom: true,
    mousewheel: true,
    freeMode: true,
    freeModeSticky: true,

    on: {
      init: function() {
        let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
        let activeSlidePos = $(this)[0].activeIndex;
        container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
      },

      slideChange: function() {
        $('.unique-gallery-thumbnail').removeClass('is-selected');

        let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
        let activeSlidePos = $(this)[0].activeIndex;
        container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
      }
    }
  });

  $(this).closest('.unique-product-gallery-wrapper').find('.unique-gallery-thumbnails [data-media-position]').on('click', function() {
    swiper.slideTo($(this).index());
  });

  $('.ProductForm__Option .HorizontalList__Item').on('click', function() {
    swiper.update();

    let container = $('.swiper-container.instance-'+index).closest('.unique-product-gallery-wrapper');
    let activeSlidePos = swiper.activeIndex;
    container.find('.unique-gallery-thumbnail').eq(activeSlidePos).addClass('is-selected');
  });
});

$('.unique-fancybox-trigger').fancybox({
  backFocus: false,
  loop: false,
  thumbs: {
    autoStart: true,
    parentEl: ".fancybox-container",
    axis: "x"
  },
  buttons: [
    //"zoom",
    //"share",
    "slideShow",
    //"fullScreen",
    //"download",
    "thumbs",
    "close"
  ]
});

// Geoloc API

$.ajax({
  typ: 'GET',
  url: 'https://api.symback.unique.paris/geoip/country',
  dataType: 'json',
  success: function(data) {
    let geoipCountry = data.geoip_country;
    let containerProduct = $('[data-section-type="product"]');
    let containerTeaser = $('.ProductItem');

    localStorage.setItem(theme.shopName + '_geoip', geoipCountry);

    if (localStorage.getItem(theme.shopName + '_geoip') !== null && localStorage.getItem(theme.shopName + '_geoip') !== 'FR' && theme.siteMode === 'b2c') {
      $('body').addClass('unique-ecommerce-disabled');

      $('.ProductMeta__PriceList, .ProductItem__PriceList').each(function() {
        $(this).html('');
      });
    }
  },
  error: function(jqxhr, textStatus, error) {
    let err = textStatus + ", " + error;
    console.log( "Request Failed: " + err );
  }
});

/* ------------------ */
/* HIDE PRICES BUTTON */
/* ------------------ */

if (theme.siteMode === 'b2b') {
  $('[data-visible-price]').on('click', function(e) {
    localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));

    if (localStorage.getItem(theme.shopName + '_visibleprice') === 'visible') {
      $(this).removeAttr('data-visible-price')
      $(this).attr('data-visible-price', 'hidden');

      $('body').removeClass('unique-visible-prices');

      localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));
    } else {
      $(this).removeAttr('data-visible-price')
      $(this).attr('data-visible-price', 'visible');

      $('body').addClass('unique-visible-prices');

      localStorage.setItem(theme.shopName + '_visibleprice', $(this).attr('data-visible-price'));
    }
  });

  if (localStorage.getItem(theme.shopName + '_visibleprice') === 'hidden' || localStorage.getItem(theme.shopName + '_visibleprice') === null) {
    $('[data-visible-price]').attr('data-visible-price', 'hidden');

    $('body').removeClass('unique-visible-prices');
  } else {
    $('[data-visible-price]').attr('data-visible-price', 'visible');

    $('body').addClass('unique-visible-prices');
  }
} else {
    localStorage.setItem(theme.shopName + '_visibleprice', 'visible');
}


  /* WISHLIST TRANSLATIONS */
  $('.titletext').html(window.i18n.wishlist['title']);
  $('.sharebutton').html(window.i18n.wishlist['share']);
  $('.clearall').html(window.i18n.wishlist['clear_all']);
  $('.product .addsingleproduct').html(window.i18n.wishlist['add_to_cart']);
  $('.product .removebutton').html(window.i18n.wishlist['remove']);

  // Show header with text and button on content loaded
  $('#heading-breadcrumbs').addClass('show-title-wishlist');




  /* --------------- */
  /* AIR DATE PICKER */
  /* --------------- */
if (theme.siteMode === 'b2b') {
  $('body').on('click', '[data-datepicker]', function(e) {
    let datePicker = $('[data-datepicker]').datepicker({
      language: theme.shopLocale,
      minDate: new Date(),
      autoClose: true,
      position: 'top left',
      dateFormat: 'dd / mm / yyyy',
      altField: '#Cart__Shipping-date',
      altFieldDateFormat: 'yyyy-mm-dd',

      onSelect: function(fd, date, inst) {
        $('.Cart__Date').html(window.languages.shippingChosenDate + fd);
        $('.Cart__Datepicker').val(window.languages.shippingDateChange);

        if(fd === '') {
          $('.Cart__Date').html('');
          $('.Cart__Datepicker').val(window.languages.shippingDateDefine);
        }
      },
      onShow: function(inst, animationCompleted) {
        if ($('#Cart__Shipping-date').val() === '') {
          $('.Cart__Date').html('');
          $('.Cart__Datepicker').val(window.languages.shippingDateDefine);
        }else {
          $('.Cart__Datepicker').val(window.languages.shippingDateChange);
        }
      }
    }).data('datepicker');

    datePicker.show();
  });
}

/* --------------------- */
/*   DATE AVAILABILITY   */
/* --------------------- */

if (theme.siteMode === 'b2b') {
  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant;
    $('[data-product-date-availbale]').html('');

    if (variant !== null && $('[data-product-'+ variant.id +'-available-date]').length) {
      let availabilityDate = $('[data-product-'+ variant.id +'-available-date]').attr('data-product-'+ variant.id +'-available-date');
      $('[data-product-date-availbale]').html(window.languages.productAvailabilityDate + availabilityDate);

    } else {
      $('[data-product-date-availbale]').html(window.languages.productAvailability);
    }

    if ($('[data-hide-add-to-cart]').length) {
      $('.ProductForm__AddToCart').replaceWith('<input type="hidden" class="ProductForm__AddToCart"/>')
    }
  });
}

/* --------------- */
/*   CART CLEAR    */
/* --------------- */
if (theme.siteMode === 'b2b') {
  $('.Form__Submit--login').on('click', function(e) {
    jQuery.post('/cart/clear.js');
  });
}


/* --------------- */
/*      LOGIN      */
/* --------------- */
if (theme.siteMode === 'b2b') {
  $('#customer_login [data-action="toggle-recover-form"]').on('click', function(e) {
    $('#recover_customer_password').removeClass('unique-hidden');
    $('#customer_login').addClass('unique-hidden');
  });

  $('#recover_customer_password [data-action="toggle-recover-form"]').on('click', function(e) {
    $('#customer_login').removeClass('unique-hidden');
    $('#recover_customer_password').addClass('unique-hidden');
  });
}